function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
//Limitless imports
import { useAppConfig } from "@limitless/common/hooks";
import { uniqueArrayBy } from "@limitless/common/utils";
import DropdownMenu from "@limitless/modern/inputs/dropdown-menu/DropdownMenu";
import { findSuggestionFromList } from "../../../utils/AutoCompleteDataUtil";
import FlagMenuItem from "../../flag/FlagMenuItem";
const LocaleFlagAutoComplete = ({
  selectedLocale,
  onValueChange,
  placeholder,
  label,
  id,
  containerClass,
  onlyCountry,
  onlyCurrencyCode,
  defaultValue,
  isMandatory = false,
  ...rest
}) => {
  const {
    countryList
  } = useAppConfig();
  const renderMenuItem = (props, item) => {
    if (!item) {
      return null;
    }
    return /*#__PURE__*/React.createElement(Box, _extends({
      component: "li",
      sx: {
        "& > img": {
          mr: 2,
          flexShrink: 0
        }
      }
    }, props), /*#__PURE__*/React.createElement(FlagMenuItem, {
      countryCode: item.countryCode,
      flag: item.flag,
      label: item.label
    }));
  };
  let countries = Array.from(countryList || []);
  if (onlyCountry) {
    countries = uniqueArrayBy(countryList, "countryCode");
  }
  if (onlyCurrencyCode) {
    countries = uniqueArrayBy(countryList, "currencyCode");
  }
  const localeList = [];
  if (defaultValue) {
    localeList.push({
      ...defaultValue,
      renderMenuItem
    });
  }
  countries.map(country => {
    const item = {
      ...country
    };
    let value = `${item.languageCode}-${item.countryCode}`;
    let label = `${item.countryDescription} - ${item.languageDescription}`;
    let flag = country.flag;
    let countryCode = item.countryCode;
    if (onlyCountry) {
      value = item.countryCode;
      label = item.countryDescription;
    }
    if (onlyCurrencyCode) {
      label = item.currencyCode;
      value = item.currencyCode;
      flag = "";
      countryCode = null;
    }
    localeList.push({
      ...item,
      countryCode,
      value,
      label,
      flag,
      renderMenuItem
    });
  });
  const locale = selectedLocale ? findSuggestionFromList(localeList, {
    value: selectedLocale.value
  }) : null;
  return /*#__PURE__*/React.createElement("div", {
    className: containerClass
  }, /*#__PURE__*/React.createElement(DropdownMenu, _extends({
    label: label,
    value: locale !== null && locale !== void 0 ? locale : {},
    id: id,
    placeholder: placeholder ? placeholder : "Select locale",
    options: localeList,
    onChange: (e, selected) => {
      if (selected.locale !== (locale === null || locale === void 0 ? void 0 : locale.locale)) {
        onValueChange(selected ? selected : null, "locale");
      }
    },
    required: isMandatory,
    renderOption: renderMenuItem
  }, rest)));
};
export default LocaleFlagAutoComplete;
LocaleFlagAutoComplete.propTypes = {
  selectedLocale: PropTypes.object,
  onValueChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  id: PropTypes.string,
  containerClass: PropTypes.string,
  onlyCountry: PropTypes.bool,
  onlyCurrencyCode: PropTypes.bool,
  defaultValue: PropTypes.object,
  isMandatory: PropTypes.bool
};
LocaleFlagAutoComplete.defaultProps = {
  placeholder: "",
  label: "Locale",
  id: "localeAutoComplete",
  containerClass: "",
  onlyCountry: false,
  onlyCurrencyCode: false
};